'use client';

import { motion } from 'motion/react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#c19964] border-t border-white/10">
      <div className="container mx-auto px-4 md:px-6">

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="py-8 border-t border-white/10 text-center text-white/80 text-xs tracking-wider"
        >
          <p>© 2025 Zed Capital Real Estate LLC - All rights reserved</p>
        </motion.div>
      </div>
    </footer>
  );
}